import { useState, useEffect } from "react";
import useWindowSize from "../../hooks/useWindowSize";
import Modal from "../../ReusableComponents/Modal";
import Form from "../../ReusableComponents/Form";
import InputField from "../../ReusableComponents/InputField";
import { Button } from "../../Components/Helper";
import { postCallingHistory, updateCallingHistory } from "../../apis/BhuMeetTeams/Telecaller/callingHistory";
import TextAreaField from "../../ReusableComponents/TextAreaInput";
import { set } from "lodash";
import { useNavigate } from "react-router";
import { updateCrmleadslog } from "../../apis/BhuMeetTeams/Crm/leadsCallHistory";

export const AddCrmcallHistory = ({ open, onClose, data, isEdit,lastRecord }) => {

    const navigate = useNavigate()

    const { currentHeight, currentWidth } = useWindowSize();
    const [historyStatus, setHistoryStatus] = useState([])
    const [lastRecordStatus,setlastRecord] = useState(lastRecord)

    const [callHistory, setcallHistory] = useState({
        
        note: '',
        campid:data.campid,
        isMarked:false,
        lead_id:data.lead_id,
        campaign_id : data.campaign_id
        

    });




    return (
        <Modal
            header={lastRecordStatus ? "Update Existing Call History" :"Add Call History"}
            open={open}
            onClose={onClose}
            contentStyle={{ width: "440px", height: "auto", borderRadius: "10px" }}
        >

            <Form
                onSubmitForm={async (form) => {
                    // console.log(form)
                    if (isEdit) {

                        await updateCrmleadslog(callHistory)
                        
                    } else {
                        await postCallingHistory(callHistory);
                    }

                    onClose()
                }}
                initialValues={callHistory}
            >
                {(onsubmit) => (
                    <div style={{
                        // display: "grid",
                        // gridTemplateColumns: "1fr",
                        // gap: currentHeight < 695 ? "2px" : "5px",
                        padding: currentHeight < 695 ? "15px 20px" : "20px",

                    }}>
                        <div style={{  maxWidth: "47%" }}>

                        <label style={{fontSize: "13px", display: "flex", alignItems: "center", gap: "10px" }}>
                                            <input
                                                type="checkbox"
                                                name="dspStatus"
                                                disabled={false}
                                                value={callHistory.isMarked}
                                                // checked={activePaymentMethods?.length === 1 && activePaymentMethods[0] === PAYMENT_METHODS.UPI}
                                                onChange={(e) => {
                                                    // console.log(e)
                                                    setcallHistory((prev) => ({ ...prev, isMarked: !callHistory.isMarked }))
                                                }}
                                                style={{ cursor: false ? "not-allowed" : "pointer" }}
                                            />
                                            {"Close call"}
                                        </label>
                            
                            <TextAreaField
                                
                                // label={"Note"}
                                value={callHistory.note}
                                // isMandotory
                                name={"English"}
                                onChange={(e)=>{
                                    let value = e.target.value
                                    setcallHistory((prev)=>({...prev,note:value}))
                                }}
                                placeholder={lastRecordStatus ? "Enter your Note and close call" :`Enter Your Note`}
                                
                                error={callHistory.note == ''}
                                height={currentHeight < 850 ? "60px" : ""}
                                marginTop={"11px"}
                                width = {"200%"}

                            />
                            



                        </div>

                        <div>


                        </div>




                        <div style={{
                            display: "flex",
                            flexDirection: "row-reverse",
                            gap: "20px",
                            padding: currentHeight < 695 ? "10px" : "20px",
                            height: "70px"
                        }}>
                            <Button
                                text={lastRecordStatus ? "Close Call" :"Add"}
                                onClick={onsubmit}
                                className={"btn-large"}
                            />
                            <Button
                                className={"btn-large lg-cancel-btn"}
                                text={"Cancel"}
                                onClick={onClose}
                                isBtnNotActive={true}
                            />
                        </div>
                    </div>
                )}
            </Form>


        </Modal>
    )
}